import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from 'hooks/useToken';
import ModalConciliarPago from 'akasia-components/administracion/pagos/ModalConciliarPago';
import ModalEditarPago from './ModalEditarPago';
import ModalRegistrarPago from './ModalRegistrarPago';
import ModalRegistrarPagoAddProduct from './ModalRegistrarPagoAddProduct';
import ModalValidarPago from './ModalValidarPago';
import PagoItem from './PagoItem';
import SelectFacturaModal from '../seccion-header/SelectFacturaModal';
import GenerarComplementoPago from 'akasia-components/Contabilidad/facturas/formulario-complemento-pago/GenerarComplementoPago';
import { useToast } from 'context/providers/ToastProvider';

const SeccionPagos = ({
    orden,
    idOrden,
    setOrden,
    guardarNotificacion,
    GuardarComentario,
    crearObjAction,
    onComentarioAgregado,
    setTienePagos,
    ObtenerDetallesOrden,
    ObtenerComentariosOrden
}) => {

    //AUTENTICACION 
    const { token, idCatTipoUsuario, setToken, nombreCompleto } = useToken();
    const [showModalValidarPago, setShowModalValidarPago] = useState(false);
    const [showModalEditarPago, setShowModalEditarPago] = useState(false);
    const [ID_Pago, setID_Pago] = useState(0);
    const [dataForm, setDataForm] = useState({});
    const [loadingRegistrarPago, setloadingRegistrarPago] = useState(false);
    const [validacion, setValidacion] = useState({})
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [showModalMarcarPagada, setShowModalRegistrarPago] = useState(false);
    const [showModalConciliar, setShowModalConciliar] = useState(false);
    const [loading, setLoading] = useState(true);
    const [formaPago, setFormaPago] = useState([]);
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [mediosDePago, setMediosDePago] = useState([]);
    const [bIsACredito, setIdBIsACredito] = useState(false);
    const [pagos, setPagos] = useState([]);
    const [showSelectFacturaModal, setShowSelectFacturaModal] = useState(false);
    const [facturasPPD, setFacturasPPD] = useState([]);
    const [selectedFacturaIndex, setSelectedFacturaIndex] = useState(0);
    const [idPagoToFacturar, setIdPagoToFacturar] = useState(0);
    const [showGenerarComplementoModal, setShowGenerarComplementoModal] = useState(false);
    const [selectedFactura, setSelectedFactura] = useState(null);
    const [addProductContext, setAddProductContext] = useState(null);
    const [showModalRegistrarPagoAddProduct, setShowModalRegistrarPagoAddProduct] = useState(false);
    const { showSuccessToast, showErrorToast } = useToast();

    const validarFormularioPago = () => {
        if (dataForm.idCatFormaPago == "") {
            showErrorToast('Es necesario que elija la forma de pago');
            setProcesandoModal(false);
            return false;
        }
        if (dataForm.dFechaPago == "") {
            showErrorToast('Debes seleccionar la fecha de Pago')
            setProcesandoModal(false);
            return false;
        }
        if (dataForm.vReferencia == "") {
            showErrorToast('Es necesario que se escriba la referencia, folio o rastreo del pago');
            setProcesandoModal(false);
            return false;
        }
        if (dataForm.dSaldoAnterior <= 0) {
            showErrorToast('El saldo a pagar no puede ser menor o igual a 0');
            setProcesandoModal(false);
            return false;
        }

        if (dataForm.dImportePagado <= 0) {
            showErrorToast('El monto del pago debe ser mayor que cero');
            setProcesandoModal(false);
            return false;
        }

        if (dataForm.dSaldoInsoluto < 0) {
            showErrorToast('El saldo insoluto no puede ser menor que cero');
            setProcesandoModal(false);
            return false;
        }

        if (dataForm.vArchivo.length == 0) {
            showErrorToast('Es obligatorio subir un comprobante de pago');
            setProcesandoModal(false);
            return false;
        }
        return true;
    }

    //Enviar Datos Para Marcar Pagada
    const onSubmitPagada = async () => {
        setProcesandoModal(true);

        var validado = validarFormularioPago();
        if (validado == false)
            return;

        var data = new FormData()
        data.append('FileName', dataForm.vNombreDocumento);
        data.append('FormFile', dataForm.vArchivo);
        data.append('vReferencia', dataForm.vReferencia);
        data.append('idOrden', idOrden);
        data.append('dFechaPago', dataForm.dFechaPago);
        data.append('dSaldoAnterior', orden.dSaldoInsoluto);
        data.append('dImportePagado', dataForm.dImportePagado);
        data.append('dSaldoInsoluto', dataForm.dSaldoInsoluto);
        data.append('idCatFormaPago', dataForm.idCatFormaPago);
        data.append('vMoneda', orden.vMoneda);
        data.append('dTipoCambio', orden.dTipoCambio);

        //Este dato se envia porque lo necesita como obligatorio la API
        data.append('vComprobante', 'XXX');
        data.append('iNumeroParcialidad', 0);
        data.append('vJsonDetallesLinkPago', (JSON.stringify(dataForm.vJsonDetallesLinkPago)));
        data.append('idPago', 0);

        const response = await fetch("/api/orden/RegistrarPago", {
            method: 'POST',
            body: data,
            headers:
            {
                'Authorization': 'Bearer ' + token
            }
        }).catch((error) => {

            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            console.log("RESULTADO DE REGISTRAR PAGO");
            console.log(data);
            
            const resultado = data.data[1][0];
            console.log("Respuesta: ", resultado);

            
            if (resultado.iResponseType === 1) {
                // Parse detalles to get nombreArchivo and datos
                //const detallesObj = JSON.parse(data.detalles);
                const datosTablas = data.data;
                console.log("datosTablas: ", datosTablas);

                //enviar notificacion a los administradores
                var objToActionString = crearObjAction(2, "/ordenes/detalle/" + datosTablas[2][0].idOrden, '', '');
                await guardarNotificacion("Pago Registrado", "<b>" + nombreCompleto + "</strong> registró un pago de <b>$" + dataForm.dImportePagado + " " + orden.vMoneda + "</strong> en la orden " + datosTablas[2][0].idOrden, 0, objToActionString, 5);
                
                // El backend (AKASIABOT) ya crea el comentario automáticamente.
                // Solo refrescamos la lista de comentarios desde el servidor.
                if (ObtenerComentariosOrden) {
                    ObtenerComentariosOrden();
                }
                
                // Actualizar detalles de la orden silenciosamente (sin skeleton)
                if (ObtenerDetallesOrden) {
                    ObtenerDetallesOrden(true);
                }
                
                setPagos(datosTablas[3]);
                setOrden({
                    ...orden,
                    dSaldoInsoluto: datosTablas[2][0].dSaldoInsoluto,
                    dFechaPrimerPago: datosTablas[4][0].dFechaPrimerPago,
                    dFechaPrimerPagoLarga: datosTablas[4][0].dFechaPrimerPagoLarga,
                    bIsPagada: datosTablas[0][0].bIsPagada
                })

                setProcesandoModal(false);
                setShowModalRegistrarPago(false);
                
                showSuccessToast("Pago registrado correctamente.");
            }
            else if (resultado.iResponseType === 2) {
                setProcesandoModal(false);
                showErrorToast(resultado.vMensaje || resultado.vMessage);
            }
            else {
                setProcesandoModal(false);
                showErrorToast(resultado.vMensaje || resultado.vMessage || "Error desconocido");
                
            }
        }
        else {
            setProcesandoModal(false);
            showErrorToast(response.status + ' ' + response.statusText);
            

            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };


    //Enviar Datos Para Editar Pago No Validado
    const onSubmitEditar = async () => {
        setProcesandoModal(true);

        var validado = validarFormularioPago();
        if (validado == false)
            return;

        var data = new FormData()
        data.append('FileName', dataForm.vNombreDocumento);
        data.append('FormFile', dataForm.vArchivo);
        data.append('vReferencia', dataForm.vReferencia);
        data.append('idOrden', idOrden);
        data.append('vComprobante', dataForm.vComprobante);
        data.append('dFechaPago', dataForm.dFechaPago);
        data.append('dSaldoAnterior', dataForm.dSaldoAnterior);
        data.append('dImportePagado', dataForm.dImportePagado);
        data.append('dSaldoInsoluto', dataForm.dSaldoInsoluto);
        data.append('idCatFormaPago', dataForm.idCatFormaPago);
        data.append('iNumeroParcialidad', dataForm.iNumeroParcialidad);
        data.append('idPago', dataForm.idPago);

        //estos datos se envían porque lo necesita olbigatoriamente la API
        data.append('vMoneda', orden.vMoneda);
        data.append('dTipoCambio', dataForm.dTipoCambio);

        if (!dataForm.vJsonDetallesLinkPago.vCardType) {
            dataForm.vJsonDetallesLinkPago.vCardCompany = null;
        }

        data.append('vJsonDetallesLinkPago', (JSON.stringify(dataForm.vJsonDetallesLinkPago)));


        const response = await fetch("/api/orden/EditarPago", {
            method: 'POST',
            body: data,
            headers:
            {
                'Authorization': 'Bearer ' + token
            }
        }).catch((error) => {
            
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            console.log("RESULTADO DE EDITAR PAGO");
            const data = await response.json();
            console.log(data);
            setPagos(data.data.table4);
            setOrden({
                ...orden,
                dSaldoInsoluto: orden.dTotal - data.data.table1[0].Column1,
                dFechaPrimerPago: data.data.table5[0].dFechaPrimerPago,
                dFechaPrimerPagoLarga: data.data.table5[0].dFechaPrimerPagoLarga,
                bIsPagada: data.data.table2[0].bIsPagada
            })

            setProcesandoModal(false);
            
            showSuccessToast(data.data.table3[0].vMensaje);
            GuardarComentario(idOrden, "<b>" + nombreCompleto + "</b></strong> editó el pago <strong>#" + dataForm.idPago + "</strong>", 2, orden, (comentarioBD) => {
                onComentarioAgregado(comentarioBD);
            }, (error) => {
                showErrorToast(error);
                
            });
            
            // Actualizar detalles de la orden silenciosamente (sin skeleton)
            if (ObtenerDetallesOrden) {
                ObtenerDetallesOrden(true);
            }
            
            setShowModalEditarPago(false);
        }
        else {
            setProcesandoModal(false);
            
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    //Enviar Datos Para Validar
    const onSubmitValidar = async () => {
        setProcesandoModal(true);
        const esMonedaMXN = validacion.vMoneda === 'MXN';
        const tipoCambioValidar = esMonedaMXN ? 1 : Number(validacion.dTipoCambio);

        if (validacion.idCatCuentaBancaria == 0) {
            showErrorToast('Es necesario que elija una cuenta de banco para validar');
            setProcesandoModal(false);
            return;
        }

        if (validacion.idCatMedioPago == 0) {
            showErrorToast('Es necesario que elija el medio de Pago');
            setProcesandoModal(false);
            return;
        }

        if (validacion.idCatFormaPago == 0) {
            showErrorToast('Es necesario que elija la forma de Pago');
            setProcesandoModal(false);
            return;
        }

        if (!esMonedaMXN && validacion.dTipoCambio == "") {
            showErrorToast('El tipo de cambio debe ser introducido');
            setProcesandoModal(false);
            return;
        }

        if (!esMonedaMXN && tipoCambioValidar <= 0) {
            showErrorToast('El tipo de cambio no puede ser menor o igual a cero');
            setProcesandoModal(false);
            return;
        }

        if (!validacion.vJsonDetallesLinkPago.vCardType) {
            validacion.vJsonDetallesLinkPago.vCardCompany = null;
        }

        var bodyTosEND = JSON.stringify({
            idPago: validacion.idPago,
            idOrden,
            idCatCuentaBancaria: validacion.idCatCuentaBancaria,
            idCatMedioPago: validacion.idCatMedioPago,
            idCatFormaPago: validacion.idCatFormaPago,
            vReferencia: validacion.vReferencia,
            dTipoCambio: tipoCambioValidar,
            vTotalPagoMoneda: validacion.dTotalPago + " " + validacion.vMoneda,
            vJsonDetallesLinkPago: validacion.vJsonDetallesLinkPago
        });

        const response = await fetch("/api/orden/ValidarPago"
            , {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: bodyTosEND
            }).catch((error) => {
                
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
                setProcesandoModal(false);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            setPagos(data.table2);
            GuardarComentario(idOrden, "<b class='badge badge-soft-success'> Validado </b> <strong>" + nombreCompleto + "</strong> validó el pago <strong>#" + validacion.idPago + "</strong>", 2, orden, (comentarioBD) => {
                onComentarioAgregado(comentarioBD);
            }, (error) => {
                showErrorToast(error);
                
            });
            
            // Actualizar detalles de la orden silenciosamente (sin skeleton)
            if (ObtenerDetallesOrden) {
                ObtenerDetallesOrden(true);
            }
            
            showSuccessToast(data.table1[0].vMensaje);
            setProcesandoModal(false);
            setShowModalValidarPago(false);
        }
        else {
            
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setProcesandoModal(false);
        }
    };

    const calcularInsoluto = (dSaldoAnterior, dPago) => {
        var dInsoluto = dSaldoAnterior - dPago;
        var idCatFormaPago = dataForm.idCatFormaPago;
        if (orden.vClave && !orden.vClave.includes('99')) {
            idCatFormaPago = orden.idCatFormaPago;
        }
        setDataForm({ ...dataForm, dSaldoInsoluto: dInsoluto, dImportePagado: dPago, idCatFormaPago: idCatFormaPago })
    }

    /**
    * Al hacer click en "Registrar pago":
    * 1. Primero consulta si la orden es flujo add-product (GetAddProductPaymentContext)
    * 2. Si sí → abre ModalRegistrarPagoAddProduct directamente (sin checkPaymentAvailable)
    * 3. Si no → corre checkPaymentAvailable y abre el modal normal si pasa
    */
    const checkPaymentAvailable = async () => {

        setloadingRegistrarPago(true);

        // Paso 1: detectar si es flujo add-product
        const ctxResponse = await fetch("/api/orden/GetAddProductPaymentContext/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idOrden })
            }).catch(() => null);

        if (ctxResponse && ctxResponse.ok) {
            const ctxObj = await ctxResponse.json();
            const detalles = ctxObj.detalles ? JSON.parse(ctxObj.detalles) : [];
            const ctx = detalles[0];
            if (ctx && ctx.bIsPendingProductPayment) {
                // Es add-product → abrir modal dedicado sin validar candado
                setAddProductContext({
                    idSuscripcion: ctx.idSuscripcion,
                    idSuscripcionDetalle: ctx.idSuscripcionDetalle
                });
                setloadingRegistrarPago(false);
                setShowModalRegistrarPagoAddProduct(true);
                return;
            }
        }

        // Paso 2: es orden normal → validar candado de pago
        setAddProductContext(null);

        var jDataSend = {};
        jDataSend.idOrden = idOrden;

        const response = await fetch("/api/orden/checkPaymentAvailable/",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response && response.ok) {
            const objResponse = await response.json();
            console.log(objResponse);

            if (objResponse.iResponseType == 1) {
                ConfigurarNoPorDefinir();
                setShowModalRegistrarPago(true);
            } else {
                showErrorToast(objResponse.vMessage);
            }

            setloadingRegistrarPago(false);
        } else if (response) {
            showErrorToast('Hubo un problema con la peticion Fetch:');
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setloadingRegistrarPago(false);
        }

    }

    const ConfigurarNoPorDefinir = () => {
        if (orden.vClave && !orden.vClave.includes('99')) {
            calcularInsoluto(orden.dSaldoInsoluto, orden.dSaldoInsoluto);
        }
    }

    const fetchFacturasPPD = async () => {
        try {
            const response = await fetch('/api/contabilidad/facturas/FacturaOrden/ObtenerFacturasPPDDeOrden', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idOrden })
            });
            const data = await response.json();
            if (response.ok && data.iResponseType === 1) {
                const detalles = JSON.parse(data.detalles);
                setFacturasPPD(detalles);
            } else {
                setFacturasPPD([]);
            }
        } catch (error) {
            setFacturasPPD([]);
        }
    };

    //Obtiene las licencias por id
    const ObtenerPagosOrden = async () => {
        setLoading(true);

        setDataForm({
            vReferencia: "",
            vArchivo: "",
            dFechaPago: "",
            dSaldoAnterior: orden.dSaldoInsoluto,
            dImportePagado: 0,
            dTipoCambio: 1,
            dSaldoInsoluto: 0,
            idCatFormaPago: "",
            vComprobante: "",
            iNumeroParcialidad: 0,
            idPago: 0,
            vJsonDetallesLinkPago: {}
        });


        setValidacion({
            dTotalPago: 0,
            vMoneda: '',
            idPago: 0,
            idCatCuentaBancaria: 0,
            dTipoCambio: 1,
            vReferencia: '',
            vMedioPago: '',
            idCatFormaPago: 0,
            idCatMedioPago: 0,
            vJsonDetallesLinkPago: {}
        });

        const response = await fetch("/api/orden/ObtenerPagosOrden/?id=" + idOrden, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);
                
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
                setLoading(false);
            });

        if (response.ok) {
            const data = await response.json();

            setIdBIsACredito(orden.vClave && orden.vClave.includes('99'));

            setCuentasBancarias(data["table1"])
            setFormaPago(data["table2"])
            setPagos(data["table3"] || [])
            setMediosDePago(data["table4"])
            ConfigurarNoPorDefinir();
            setLoading(false);

            // 🆕 Actualizar estado de tienePagos para deshabilitar edición de precios
            if (setTienePagos) {
                setTienePagos(data["table3"] && data["table3"].length > 0);
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setLoading(false);
        }
    };

    const handleEditPago = (p) => {
        let parsedJson = {};
        if (p.vJsonDetallesLinkPago && p.vJsonDetallesLinkPago !== "undefined") {
            parsedJson = JSON.parse(p.vJsonDetallesLinkPago);
        }
        const isJsonVacio = Object.keys(parsedJson).length === 0;

        setShowModalEditarPago(true);
        setDataForm({
            vReferencia: p.vReferencia,
            vArchivo: "",
            dFechaPago: p.dFechaPago,
            dSaldoAnterior: p.dSaldoAnterior,
            dImportePagado: p.dImportePago,
            dSaldoInsoluto: p.dSaldoInsoluto,
            idCatFormaPago: p.idCatFormaPago,
            dTipoCambio: p.dTipoCambio,
            iNumeroParcialidad: p.iNumeroParcialidad,
            idPago: p.idPago,
            vComprobante: p.vComprobante,
            vJsonDetallesLinkPago: isJsonVacio
                ? {
                    vCardType:
                        p.idCatFormaPago === 4
                            ? 'credit'
                            : p.idCatFormaPago === 18
                                ? 'debit'
                                : ''
                }
                : parsedJson
        });
    };

    const handleValidarPago = (p) => {
        let parsedJson = {};
        if (p.vJsonDetallesLinkPago && p.vJsonDetallesLinkPago !== "undefined") {
            parsedJson = JSON.parse(p.vJsonDetallesLinkPago);
        }
        const isJsonVacio = Object.keys(parsedJson).length === 0;

        setShowModalValidarPago(true);
        setValidacion({
            ...validacion,
            dTotalPago: p.dImportePago,
            vMoneda: p.vMoneda,
            idPago: p.idPago,
            idCatCuentaBancaria: p.idCatCuentaBancaria,
            dTipoCambio: p.vMoneda === 'MXN' && (!p.dTipoCambio || Number(p.dTipoCambio) <= 0) ? 1 : p.dTipoCambio,
            vReferencia: p.vReferencia,
            idCatFormaPago: p.idCatFormaPago,
            idCatMedioPago: p.idCatFormaPago === 4 ? 18 : p.idCatFormaPago === 18 ? 4 : 0,
            vMedioPago: '',
            vJsonDetallesLinkPago: isJsonVacio
                ? {
                    vCardType:
                        p.idCatFormaPago === 4
                            ? 'credit'
                            : p.idCatFormaPago === 18
                                ? 'debit'
                                : ''
                }
                : parsedJson
        })
    };

    useEffect(() => {
        ObtenerPagosOrden();
    }, [orden])

    return (

        loading ? <Skeleton width={300} count={5} /> :
            <>
                <h5 className="mb-3 fs-0">Historial de pagos</h5>
                {pagos && pagos.map((p, i) => (
                    <PagoItem
                        key={i}
                        pago={p}
                        idCatTipoUsuario={idCatTipoUsuario}
                        onEdit={() => handleEditPago(p)}
                        onValidar={() => handleValidarPago(p)}
                        onConciliar={(idPago) => { setID_Pago(idPago); setShowModalConciliar(true) }}
                        onFacturar={(idPago) => { setIdPagoToFacturar(idPago); fetchFacturasPPD(); setShowSelectFacturaModal(true); }}
                        orden={orden}
                    />
                ))}
                {orden.bIsPagada === false && (
                    <>
                        {orden.bIsActive && (
                            <>
                                {loadingRegistrarPago ? (
                                    <Button variant="falcon-primary" size="sm">
                                        <Spinner
                                            as="span"
                                            animation="grow"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        &nbsp;Procesando...
                                    </Button>
                                ) : (
                                    <Button
                                        size="sm"
                                        className='me-2 mb-2'
                                        onClick={() => { checkPaymentAvailable(); }}
                                        variant="falcon-primary"
                                    >
                                        Registrar pago
                                    </Button>
                                )}
                            </>
                        )}
                    </>
                )}

                {/* Modal para registrar un pago - comprobante de pago */}
                <ModalRegistrarPago
                    show={showModalMarcarPagada}
                    onHide={() => setShowModalRegistrarPago(false)}
                    orden={orden}
                    dataForm={dataForm}
                    setDataForm={setDataForm}
                    formaPago={formaPago}
                    bIsACredito={bIsACredito}
                    calcularInsoluto={calcularInsoluto}
                    onSubmit={onSubmitPagada}
                    procesandoModal={procesandoModal}
                />

                <ModalRegistrarPagoAddProduct
                    show={showModalRegistrarPagoAddProduct}
                    onHide={() => { setShowModalRegistrarPagoAddProduct(false); setAddProductContext(null); }}
                    orden={orden}
                    idOrden={idOrden}
                    formaPago={formaPago}
                    addProductContext={addProductContext}
                    token={token}
                    setToken={setToken}
                    onSuccess={() => { 
                        setShowModalRegistrarPagoAddProduct(false); 
                        setAddProductContext(null); 
                        ObtenerPagosOrden();
                        if (ObtenerDetallesOrden) {
                            ObtenerDetallesOrden(true);
                        }
                    }}
                />

                {/* Modal para editar un pago no validado */}
                <ModalEditarPago
                    show={showModalEditarPago}
                    onHide={() => setShowModalEditarPago(false)}
                    orden={orden}
                    dataForm={dataForm}
                    setDataForm={setDataForm}
                    formaPago={formaPago}
                    bIsACredito={bIsACredito}
                    calcularInsoluto={calcularInsoluto}
                    onSubmit={onSubmitEditar}
                    procesandoModal={procesandoModal}
                />

                {/* Modal para validar un pago */}
                <ModalValidarPago
                    show={showModalValidarPago}
                    onHide={() => setShowModalValidarPago(false)}
                    validacion={validacion}
                    setValidacion={setValidacion}
                    cuentasBancarias={cuentasBancarias}
                    mediosDePago={mediosDePago}
                    formaPago={formaPago}
                    onSubmit={onSubmitValidar}
                    procesandoModal={procesandoModal}
                />

                {showModalConciliar &&
                    <ModalConciliarPago
                        showModalConciliar={showModalConciliar}
                        setShowModalConciliar={setShowModalConciliar}
                        idPago={ID_Pago}
                        GuardarComentario={GuardarComentario}
                        orden={orden}
                        onComentarioAgregado={onComentarioAgregado}
                    />
                }
                <SelectFacturaModal
                    show={showSelectFacturaModal}
                    onHide={() => setShowSelectFacturaModal(false)}
                    facturas={facturasPPD}
                    selectedIndex={selectedFacturaIndex}
                    setSelectedIndex={setSelectedFacturaIndex}
                    onConfirm={() => { 
                        setSelectedFactura(facturasPPD[selectedFacturaIndex]); 
                        setShowGenerarComplementoModal(true); 
                        setShowSelectFacturaModal(false); 
                    }}
                    title="Seleccionar factura PPD"
                />
                <GenerarComplementoPago
                    show={showGenerarComplementoModal}
                    onHide={() => setShowGenerarComplementoModal(false)}
                    idPago={idPagoToFacturar}
                    idOrden={parseInt(idOrden)}
                    selectedFactura={selectedFactura}
                    orden={orden}
                />
            </>
    )
}

SeccionPagos.propTypes = {
    orden: PropTypes.object,
    setOrden: PropTypes.func,
    idOrden: PropTypes.string,
    guardarNotificacion: PropTypes.func,
    GuardarComentario: PropTypes.func,
    ObtenerDetallesOrden: PropTypes.func,
    ObtenerComentariosOrden: PropTypes.func,
    crearObjAction: PropTypes.func,
    onComentarioAgregado: PropTypes.func,
    setTienePagos: PropTypes.func
};

export default SeccionPagos;

